module.exports = __webpack_public_path__ + "img/66.cc141957.webp";